module.exports = __webpack_public_path__ + "img/Malaysia-5-hover.3b313650.jpg";